module.exports = __webpack_public_path__ + "static/media/page-13.98bb7f73.png";